import { queryClient } from "@app/config/queryClient";
import { router } from "@app/config/router";
import { OverlayProvider } from "@base/model/hooks/useOverlay";
import { Toaster } from "@base/ui/Toaster/Toaster";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";

export function AppProviders() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} InnerWrap={({ children }) => <OverlayProvider>{children}</OverlayProvider>} />
      <Toaster />
    </QueryClientProvider>
  );
}
